import { render } from "./Header.vue?vue&type=template&id=3bb505f7&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=3bb505f7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb505f7"]])

export default __exports__